export enum StoreTabEnum {
  theme = 'theme',
  profile = 'profile',
  link = 'link',
  optin = 'optin',
  product = 'product',
  storeSettings = 'storeSettings',
}
